import React from "react";

import Checkbox from "ui/atoms/Checkbox";

interface TableSelectProps {
  rowId: string;
  setSelectedRowIds: React.Dispatch<React.SetStateAction<string[]>>;
  onSetSelectedRowIdsCallback?: () => void;
  checked: boolean;
}

const TableSelect: React.FC<TableSelectProps> = ({
  rowId,
  setSelectedRowIds,
  onSetSelectedRowIdsCallback,
  checked,
}) => {
  const handleToggleRowSelection = (rowId: string): void => {
    setSelectedRowIds((currentSelectedRowIds) => {
      if (currentSelectedRowIds.includes(rowId)) {
        // Remove ID if it is already selected
        return currentSelectedRowIds.filter((id) => id !== rowId);
      } else {
        // Add ID if it is not selected
        return [...currentSelectedRowIds, rowId];
      }
    });

    if (onSetSelectedRowIdsCallback) {
      onSetSelectedRowIdsCallback();
    }
  };

  return (
    <Checkbox
      onChange={() => handleToggleRowSelection(rowId)}
      checked={checked}
    />
  );
};

export default TableSelect;
